/* eslint-disable indent */
import styled, { css } from 'styled-components';
import { getUrlWithToken } from '../../../utils/common';

export const Container = styled.div`
  position: relative;
  border-radius: 4px;
  transition: ${(props) => props.theme.constants.transitionBase};
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin: 0 auto;
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 100%;
  height: 100%;
  margin: unset;

  &.news {
    padding: 10px;
    gap: 10px;
    &.large {
      gap: 16px;
      & > div:first-child {
        height: 210px;
      }
    }
  }

  &.large {
    grid-column-start: 1;
    grid-column-end: 4;
    flex-direction: row;
    height: 230px;

    & > div:first-child {
      max-width: calc(33% - 10px);
      border-radius: 4px 0 0 4px;
      height: 230px;
      > div {
        border-radius: 4px 0 0 4px;
      }
    }

    .bottom {
      width: 100%;
      height: 100%;
    }
  }
`;

export const Bottom = styled.div`
  z-index: 1;
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: calc(100% - 187px);

  & .card-details {
    margin-top: auto;
    margin-left: auto;
  }
`;

export const Banner = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 32px;
  width: 178px;
  color: ${(props) => props.theme.colors.white};
  z-index: 0;
  position: absolute;
  top: 31px;
  right: -42px;
  transform: rotate(45deg);
  text-transform: uppercase;
  font-size: 14px;
  font-weight: bold;

  ${({ bigger }) =>
    bigger &&
    css`
      height: 42px;
      right: -46px;
      top: 23px;
    `}

  &:before {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    bottom: 0;
    height: 4px;
    width: 12px;
    transform: rotate(-45deg);
  }

  &:after {
    content: '';
    display: block;
    position: absolute;
    right: 0;
    bottom: 0;
    height: 4px;
    width: 12px;
    transform: rotate(45deg);
  }

  & > div {
    z-index: 1;
    height: inherit;
    width: inherit;
    position: absolute;
    top: 0;
    left: 0;
    text-align: center;
    padding: 8px;

    ${({ bigger }) =>
      bigger &&
      css`
        padding: 8px 31px;
      `}

    &:after {
      content: '';
      display: block;
      width: inherit;
      height: inherit;
      position: absolute;
      top: 0;
      left: 0;
      clip-path: polygon(17.8% 0%, 82% 0%, 100% 100%, 0% 100%);
      border-top-left-radius: 50px;
      border-top-right-radius: 50px;
      z-index: -1;

      ${({ bigger }) =>
        bigger &&
        css`
          clip-path: polygon(23% 0%, 76% 0%, 100% 100%, 0% 100%);
        `}
    }
  }
`;

export const CardsGrid = styled.div`
  justify-content: space-between;
  gap: 20px;
  padding: 1rem 0 3rem;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 20px;

  @media ${(props) => props.theme.device.laptop} {
    grid-template-columns: 1fr 1fr;
    gap: 16px;
  }
`;

export const Cover = styled.div.withConfig({
  shouldForwardProp: (prop) => !['cover'].includes(prop),
})`
  background: url(${({ cover }) => getUrlWithToken(cover)});
  width: 100%;
  min-width: 200px;
  height: 187px;
  background-size: cover;
  background-position: center center;
  position: relative;
  border-radius: 4px 4px 0 0;
  cursor: pointer;
`;

export const Overlay = styled.div`
  background: linear-gradient(
    0deg,
    #050505 -13.37%,
    rgba(255, 255, 255, 0) 104.73%
  );
  border-radius: 4px 4px 0 0;
  width: 100%;
  height: inherit;
`;

export const Title = styled.div`
  font-size: 18px;
  font-weight: bold;
  line-height: 1.22;
  margin-bottom: 14px;
  color: ${(props) => props.theme.colors.title};
  cursor: pointer;

  &.news {
    margin-bottom: 4px;
  }
`;

export const Description = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: ${(props) => props.theme.colors.textPrimary};
  margin-bottom: 16px;

  overflow: hidden;
  display: -webkit-inline-box;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
`;
export const Categories = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: ${(props) => props.theme.colors.textPrimary};
  margin-bottom: 16px;
`;
